import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { history } from 'store/configureStore';
import AuthedHeader from './authedHeader';
import { admAccounts, programFiles } from 'const';

/**
 * ヘッダーコンポーネント
 */
const Header = () => {
  const routes = [];
  for (const ii in admAccounts) {
    routes.push(<Route exact key={admAccounts[ii]} path={admAccounts[ii]} component={AuthedHeader} />);
  }
  for (const ii in programFiles) {
    routes.push(<Route exact key={programFiles[ii]} path={programFiles[ii]} component={AuthedHeader} />);
  }
  // スタートページ
  routes.push(<Route exact key="start" path="/start" component={AuthedHeader} />);

  return (
    <ConnectedRouter history={history}>
      <Switch>
        {/* 管理者アカウント系画面かユーザー系画面であれば管理者アカウントのヘッダーを表示 */}
        {routes}
      </Switch>
    </ConnectedRouter>
  );
};

export default Header;
